import { render, staticRenderFns } from "./FotosPorAlunoModal.vue?vue&type=template&id=614a547d&scoped=true"
import script from "./FotosPorAlunoModal.vue?vue&type=script&lang=js"
export * from "./FotosPorAlunoModal.vue?vue&type=script&lang=js"
import style0 from "./FotosPorAlunoModal.vue?vue&type=style&index=0&id=614a547d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a547d",
  null
  
)

export default component.exports